import React, { useRef } from 'react';
import s from './s.module.less';

const GenderSelector = ({ value, onChange }: { value?: string; onChange?: (gender: string) => void }) => {
    const genderOptions = useRef([
        'Female',
        'Male',
        'Non-binary',
        'Transgender',
        'A gender not listed here',
        'Prefer not to say',
    ]);
    return (
        <div className={s.optionsContainer}>
            {genderOptions.current.map((option) => (
                <div
                    key={option}
                    className={`${s.option} ${value === option ? s.selected : ''}`}
                    onClick={() => onChange?.(option)}
                >
                    {option}
                </div>
            ))}
        </div>
    );
};

interface IProps {
    gender?: string;
    onChange?: (gender: string) => void;
    wrapClassName?: string;
}

const Step4 = ({ gender, onChange, wrapClassName }: IProps) => {
    return (
        <div className={`${s.wrap} ${wrapClassName || ''}`}>
            <h2>What is your gender identity?</h2>
            <p>
                This answer helps patients who prefer a provider with a specific gender identity find the right match.
            </p>
            <GenderSelector value={gender} onChange={onChange} />
        </div>
    );
};

export default Step4;
